import NavigationCard from './NavigationCard'
import pharmacyIcon from '../../../resources/pharmacy.png'
import CardIconHmo from '../../../resources/Home.card.Hmo.png'
import CoverageIconHmo from '../../../resources/profile.coverage.png'
import emergencyIcon from '../../../resources/emergency.png'
import { useDispatch, useSelector } from 'react-redux'
import { Avatar, Spin } from 'antd'
import { useEffect } from 'react'
// import { useRef } from 'react' // TODO: Uncomment when profile picture upload is re-enabled
import actions from '../../../actions'
// import { getBase64 } from '../../../utils/profilePictureUtil' // TODO: Uncomment when profile picture upload is re-enabled
import $t from '../../../i18n'
import { routes } from '../../../consts'
import PageCard from '../../common/PageCard'
import ActionButton from '../../common/ActionButton'
import { isMembershipPlanActive } from '../../../utils/familyUtils'
import { getUserSubscription } from '../../../utils/paymentUtils'
import config from '../../../config.json'
import dayjs from 'dayjs'
import { getMvpDate, isPatientMvp } from '../../../utils/onBoardingUtils'
import { GenderIdentities, Pronouns } from '../../../consts/Profile'
import { getIsHmoMember } from '../../../utils/hmoUtils'

import './profile.css'
import { event, eventTypes } from '../../../consts/eventConsts'

const Profile = () => {
  const { userDetails, isUserDetailsLoading } = useSelector(
    state => state.profile
  )

  const dispatch = useDispatch()
  // const inputFile = useRef(null)
  // const openFilePicker = () => {
  //   inputFile.current.click()
  // }
  const isHmoMember = getIsHmoMember(userDetails)
  const { isMinorApp } = useSelector(state => state.app)
  const my_subscriptions = useSelector(state => state.payment.my_subscriptions)
  const future_subscriptions = useSelector(
    state => state.payment.future_subscriptions
  )
  const hmoSubscription = getUserSubscription(
    my_subscriptions,
    future_subscriptions
  )

  const isFamilyPlanActive = isMembershipPlanActive(my_subscriptions)
  const isMvp = isPatientMvp(userDetails)
  const mvpDate = isMvp ? getMvpDate(userDetails) : null

  const telehealthPcp = userDetails?.telehealthPcp
  const physicalPcp = userDetails?.physicalPcp
  // get the current physical pcp (if we have just one , get the first. if we have more than one, get the one that contains end date)
  const currentPhysicalPcp =
    physicalPcp?.length > 1
      ? physicalPcp?.find(pcp => !!pcp?.end_date)
      : physicalPcp?.[0]

  useEffect(() => {
    if (!userDetails) {
      dispatch(actions.createAction(actions.USER_PROFILE_REQUESTED))
    }
  }, [])

  const handleNavigation = item => {
    if (item?.action) {
      dispatch(
        actions.createAction(item.action, { from: routes.MENU_ROUTE.PROFILE })
      )
      dispatch(
        actions.createAction(actions.ANALYTICS_EVENT_FIRED, {
          type: eventTypes.click,
          eventName: event.clickEvent.click,
          element: item?.label,
        })
      )
    }
  }
  const handlePharmacyModal = () => {
    dispatch(
      actions.createAction(actions.UPDATE_MY_PHARMACY_PRESSED, {
        from: routes.MENU_ROUTE.PROFILE,
      })
    )
    dispatch(
      actions.createAction(actions.ANALYTICS_EVENT_FIRED, {
        eventName: actions.UPDATE_MY_PHARMACY_PRESSED + '_WEB',
        data: { from: 'Profile' },
      })
    )
  }

  const handleEmergencyModal = () => {
    dispatch(
      actions.createAction(actions.UPDATE_EMERGENCY_CONTACT_PRESSED, {
        from: routes.MENU_ROUTE.PROFILE,
      })
    )
    dispatch(
      actions.createAction(actions.ANALYTICS_EVENT_FIRED, {
        eventName: actions.UPDATE_EMERGENCY_CONTACT_PRESSED + '_WEB',
        data: { from: 'Profile' },
      })
    )
  }

  // const handleProfilePicture = async e => {
  //   try {
  //     let base64 = await getBase64(e.target.files[0])
  //     dispatch(
  //       actions.createAction(actions.USER_PROFILE_PICTURE_CHANGE_REQUESTED, {
  //         profilePicture: base64,
  //       })
  //     )
  //   } catch (error) {
  //     dispatch(actions.createAction(actions.OPERATION_FAILED, { error }))
  //   }
  // }

  const handleChangeGender = () => {
    dispatch(actions.createAction(actions.UPDATE_GENDER_DETAILS_PRESSED))
  }

  const OnIdCardPressed = () => {
    dispatch(
      actions.createAction(actions.NAVIGATED_TO, routes.PROFILE_ROUTE.ID_CARDS)
    )
  }

  const getGenderIdentity = () => {
    let currGenderIdentity = ''
    if (userDetails?.genderIdentity) {
      Object.values(GenderIdentities).forEach(item => {
        if (item.key === userDetails?.genderIdentity) {
          currGenderIdentity = $t(item.text)
        }
      })
      return currGenderIdentity
    }
  }

  const getPronoun = () => {
    let currPronoun = ''
    if (userDetails?.pronoun) {
      Object.values(Pronouns).forEach(item => {
        if (item.key === userDetails?.pronoun) {
          currPronoun = $t(item.text)
        }
      })
      return currPronoun
    }
  }

  const renderGenderText = () => {
    if (userDetails?.genderIdentity || userDetails?.pronoun) {
      return `${getGenderIdentity()} ${
        userDetails?.pronoun ? `(${getPronoun()})` : ''
      }`
    }
    return $t('profile.genderDetails.selectGender')
  }

  const ProfileNavigatorsList = isHmoMember
    ? [
        {
          label: $t('profile.careTeam.title'),
          action: actions.CARE_TEAM_PRESSED,
          desc: (
            <div>
              {telehealthPcp?.name && (
                <div className="row">
                  {telehealthPcp?.name}, {$t('profile.careTeam.telehealthPCP')}
                </div>
              )}
              {currentPhysicalPcp?.name && (
                <div className="row">
                  {currentPhysicalPcp?.name}, {$t('profile.careTeam.pcp')}
                </div>
              )}
            </div>
          ),
          hidden: isMinorApp,
        },
        {
          label: $t('profile.mvpStatus'),
          action: actions.MVP_STATUS_PRESSED,
          hidden: isMinorApp,
        },
        {
          label: $t('profile.preferredPharmacy'),
          action: actions.UPDATE_MY_PHARMACY_PRESSED,
          desc: userDetails?.pharmacy ? (
            <div>
              <div className="row">{userDetails?.pharmacy?.StoreName}</div>
              <div className="row">
                {[
                  userDetails?.pharmacy?.Address1,
                  userDetails?.pharmacy?.Address2,
                  userDetails?.pharmacy?.City,
                  userDetails?.pharmacy?.State,
                  userDetails?.pharmacy?.ZipCode,
                ]
                  .filter(val => !!val)
                  .join(', ')}
              </div>
            </div>
          ) : (
            ''
          ),
          hidden: isMinorApp,
        },
        {
          label: $t('profile.contactInformation'),
          action: actions.CONTACT_INFORMATION_PRESSED,
          hidden: isMinorApp,
        },
        {
          label: $t('profile.settingsPreferences'),
          action: actions.SETTING_PREFERENCES_PRESSED,
        },
        {
          label: $t('profile.emergencyContact'),
          action: actions.UPDATE_EMERGENCY_CONTACT_PRESSED,
          hidden: isMinorApp,
        },
        {
          label: $t('profile.consents'),
          action: actions.CONSENTS_CLICK,
          hidden: isMinorApp,
        },
      ]
    : [
        {
          label: $t('profile.contactInformation'),
          action: actions.CONTACT_INFORMATION_PRESSED,
          hidden: isMinorApp,
        },
        {
          label: $t('profile.settingsPreferences'),
          action: actions.SETTING_PREFERENCES_PRESSED,
        },
        {
          label: $t('profile.accountStatus'),
          action: actions.ACCOUNT_STATUS_PRESSED,
          hidden: isMinorApp || !isFamilyPlanActive,
        },
        {
          label: $t('profile.myFamily'),
          action: actions.MY_FAMILY_CLICK,
          hidden: isMinorApp,
        },
        {
          label: $t('profile.myDiscountCard'),
          action: actions.DISCOUNT_CARD_CLICK,
          hidden: isMinorApp,
        },
        {
          label: $t('profile.consents'),
          action: actions.CONSENTS_CLICK,
          hidden: isMinorApp,
        },
      ]

  return (
    <PageCard className="profile-container">
      <div
        className={
          isMinorApp
            ? 'profile-cards-container minor'
            : 'profile-cards-container regular'
        }
      >
        {isUserDetailsLoading ? (
          <Spin size="large" />
        ) : (
          <>
            <div className="profile-card">
              {/* TODO: Fix later - Profile picture upload feature temporarily disabled */}
              <div
                className="profile-image-wrapper trackable"
                data-name="profile-image"
                // onClick={openFilePicker}
              >
                {/* <input
                  type="file"
                  id="file"
                  accept="image/*"
                  ref={inputFile}
                  onChange={handleProfilePicture}
                  className="file-picker trackable"
                  data-name="change-profile-picture"
                /> */}
                {userDetails?.profilePicture && (
                  <img
                    src={
                      userDetails?.profilePicture?.uri
                        ? userDetails?.profilePicture?.uri
                        : userDetails?.profilePicture
                    }
                    className="profile-img"
                    alt="user"
                  ></img>
                )}
                {!userDetails?.profilePicture && (
                  <Avatar className="profile-avatar" size={106}>
                    {userDetails?.firstName?.toUpperCase()?.slice(0, 1) +
                      userDetails?.lastName?.toUpperCase()?.slice(0, 1)}
                  </Avatar>
                )}
                {/* <div className="camera-img-wrapper">
                  {!userDetails?.profilePicture && (
                    <i className="camera-icon icon-big-plus" />
                  )}
                  {userDetails?.profilePicture && (
                    <i className="camera-icon icon-edit" />
                  )}
                </div> */}
              </div>
              <h1 className="profile-name">
                {userDetails?.firstName} {userDetails?.middleName}{' '}
                {userDetails?.lastName}
              </h1>
              {!isMinorApp && (
                <div
                  className="profile-gender light"
                  onClick={handleChangeGender}
                >
                  {renderGenderText()}
                  <i className="edit-gender trackable icon-edit" />
                </div>
              )}
              {isHmoMember && (
                <>
                  <div className="divider profile-divider-upper"></div>
                  {isMvp && (
                    <div className="mvp-status">
                      {$t('pages.mvpStatus.titleMvp', {
                        date: mvpDate,
                      })}
                    </div>
                  )}
                  <div className="profile-memberid semi-bold">
                    {$t('profile.memberId')} {userDetails?.hmo_member_id}
                  </div>
                </>
              )}
              {hmoSubscription && !isHmoMember && (
                <div className="profile-plan">
                  {`${$t('profile.plan')} ${hmoSubscription?.plan_name} | ${$t(
                    'profile.startDate'
                  )} ${dayjs(hmoSubscription?.created_at).format(
                    config.planDateFormat
                  )}`}
                </div>
              )}

              {isHmoMember && hmoSubscription && (
                <div className="profile-plan">
                  {`${$t('profile.plan')} ${hmoSubscription?.plan_name} | ${$t(
                    'profile.coverageEffective'
                  )} ${dayjs(userDetails?.hmo_effective_begin_date).format(
                    config.planDateFormat
                  )}`}
                </div>
              )}
              <div className="divider profile-divider-lower"></div>
              {!isMinorApp && (
                <div className="profile-contact-container">
                  {isHmoMember && (
                    <>
                      <ActionButton
                        key={'idCards'}
                        label={$t('profile.idCards')}
                        onPress={OnIdCardPressed}
                        image={CardIconHmo}
                        className="action-btn trackable"
                        displayArrow={true}
                      />
                      <ActionButton
                        key={'coverage'}
                        image={CoverageIconHmo}
                        label={$t('profile.coverage')}
                        className="action-btn trackable"
                        onPress={() =>
                          dispatch(
                            actions.createAction(
                              actions.NAVIGATED_TO,
                              routes.PROFILE_ROUTE.COVERAGE
                            )
                          )
                        }
                        displayArrow={true}
                      />
                    </>
                  )}
                  {!isHmoMember && (
                    <>
                      <ActionButton
                        label={$t('profile.preferredPharmacy')}
                        className="action-btn trackable"
                        onPress={handlePharmacyModal}
                        image={pharmacyIcon}
                      />
                      <ActionButton
                        label={$t('profile.emergencyContact')}
                        className="action-btn trackable"
                        onPress={handleEmergencyModal}
                        image={emergencyIcon}
                      />
                    </>
                  )}
                </div>
              )}
            </div>
            <div className="navigation-card-container">
              <div className="navigation-container">
                {ProfileNavigatorsList.filter(action => !action.hidden).map(
                  (item, index) => (
                    <div key={index}>
                      <NavigationCard
                        key={index}
                        label={item.label}
                        className="trackable"
                        desc={item.desc}
                        handleClick={() => handleNavigation(item)}
                      ></NavigationCard>
                      <div className="divider"></div>
                    </div>
                  )
                )}
              </div>
            </div>
          </>
        )}
      </div>
    </PageCard>
  )
}

export default Profile
